import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const TextLink = styled(Link)`
  color: #175cd3;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
